module.exports = __webpack_public_path__ + "static/media/8077b97cc44785736c26699fb82286a3.ddc9b72c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/8077b97cc44785736c26699fb82286a3.jpg
// module id = 299
// module chunks = 0